export var windowStage;
(function (windowStage) {
  windowStage["DEFAULT"] = "DEFAULT";
  windowStage["FULLSCREEN"] = "FULLSCREEN";
  windowStage["MINIMIZED"] = "MINIMIZED";
})(windowStage || (windowStage = {}));